globalThis.appVisitor = globalThis.appVisitor || {};
appVisitor.blog = appVisitor.blog || {};

appVisitor.blog.actionsController = (function() {
  function ActionsController($html) {
    this.$html = $html;
  }

  ActionsController.prototype = {
    init: function () {
      this.initEvents();
    },

    initEvents: function () {
      var me = this;

      me.$html.on('mouseenter mouseleave', '.share-button-wrapper', function(event) {
        var $buttonsContainer = me.$html.find('.blog-article-page-social-media-share-buttons');

        switch (event.type) {
          case 'mouseenter':
            $buttonsContainer.fadeIn();
            break;
          case 'mouseleave':
            $buttonsContainer.fadeOut();
            break;
        }
      });
    },
  }

  return ActionsController;
})();
